import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectOrder, selectPhotos, setPhotos } from "./orderSlice";
import "./orderPhotos.css";
import { FaCamera, FaClipboard, FaPlus, FaImage, FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { deletePhoto, getOrderPhotos } from "./orderApi";

export default function OrderPhotos({ role, startCamera, pasteImageFromClipboard, pickImage, isUploading }) {
    const dispatch = useDispatch();
    const photos = useSelector(selectPhotos);
    const order = useSelector(selectOrder)
    const [showFullScreen, setShowFullScreen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleShowPhotoFullScreen = (index) => {
        setCurrentIndex(index);
        setShowFullScreen(true);
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % photos.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + photos.length) % photos.length);
    };

    const handleDelPhoto = (id) => {
        const confirmed = window.confirm("Вы уверены, что хотите удалить эту фотографию?");
        if (confirmed) {
            deletePhoto({ id: id }, (data) => {
                setShowFullScreen(false); // если открыто полноэкранное фото
                getOrderPhotos({ order_id: order.id }, (data) => {
                    dispatch(setPhotos(data.photos));
                });
            });
        }
    };


    return (
        <div className="order-photos-container">
            <div className="order-photos-header">
                <h4 className="order-photos-title">Фото</h4>
                {role !== "doctor" && (
                    <div className="order-photos-actions">
                        <button onClick={startCamera}><FaCamera /></button>
                        <button onClick={pasteImageFromClipboard}><FaClipboard /></button>
                        <button onClick={pickImage}><FaImage /></button>
                    </div>
                )}
            </div>

            <div className="order-photos-scroll">
                {[...photos, "plus"].map((photo, i) => (
                    <div key={i} className="order-photo-wrapper">
                        {photo === "plus" && role !== "doctor" && (
                            <button
                                onClick={!isUploading ? startCamera : null}
                                className="photo-add-btn"
                            >
                                {isUploading ? <span>Загрузка...</span> : <FaPlus />}
                            </button>
                        )}
                        {photo !== "plus" && (
                            <div className="photo-container">
                                <img
                                    src={`${process.env.REACT_APP_API_URL}static/uploads/${photo.url_photo}`}
                                    alt={`Фото ${i}`}
                                    className="order-photo"
                                    onClick={() => handleShowPhotoFullScreen(i)}
                                />

                                {role !== "doctor" && (
                                    <button
                                        className="delete-photo-btn"
                                        onClick={() => handleDelPhoto(photo.id)}
                                    >
                                        &times;
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>


            {showFullScreen && photos[currentIndex] && (
                <div className="photo-fullscreen-overlay">
                    <button className="close-btn" onClick={() => setShowFullScreen(false)}><FaTimes /></button>
                    <button className="prev-btn" onClick={handlePrev}><FaArrowLeft /></button>
                    <img
                        src={`${process.env.REACT_APP_API_URL}static/uploads/${photos[currentIndex].url_photo}`}
                        alt="fullscreen"
                        className="fullscreen-photo"
                    />

                    <button className="next-btn" onClick={handleNext}><FaArrowRight /></button>
                </div>
            )}
        </div>
    );
}
